import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.classSchoolList.loading;
export const selectErrorMessage = (state: RootState) =>
  state.classSchoolList.error;
export const classListDataResponse = (state: RootState) =>
  state.classSchoolList.classesSchoolResponse;
